import { render } from "./FailOverPage.vue?vue&type=template&id=dc71e3e6&scoped=true"
import script from "./FailOverPage.vue?vue&type=script&lang=js"
export * from "./FailOverPage.vue?vue&type=script&lang=js"

import "./FailOverPage.vue?vue&type=style&index=0&id=dc71e3e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc71e3e6"]])

export default __exports__